var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.122,
    height: 34.457,
    viewBox: "0 0 46.122 34.457",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "age",
    transform: "translate(-5195.901 -1473.715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    "data-name": "Group 296"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M5241.889,1477.242a4.564,4.564,0,0,0-4.62-3.522l-30.688,0q-3.063,0-6.129.007a4.523,4.523,0,0,0-4.326,3.168c-.061.183-.113.368-.164.553l-.061.213v26.506a.391.391,0,0,1,.068.173,4.649,4.649,0,0,0,4.741,3.835h.013q12.62-.03,25.242-.015l11.305,0a4.583,4.583,0,0,0,4.75-4.719q.007-12.5,0-25A5.245,5.245,0,0,0,5241.889,1477.242Zm-4.68,29.577q-9.125,0-18.248,0t-18.249,0a3.248,3.248,0,0,1-3.47-3.46q-.005-12.409,0-24.818a3.268,3.268,0,0,1,3.495-3.481l13.272,0h9.953l13.272,0a3.242,3.242,0,0,1,3.313,2.368,4.135,4.135,0,0,1,.13,1.069q.011,12.432,0,24.864A3.248,3.248,0,0,1,5237.209,1506.819Z",
    fill: "#6291f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M5214.081,1493.19c-1.185-.021-2.4-.031-3.7-.031-1.259,0-2.592.01-4.044.029a4.44,4.44,0,0,0-4.452,3.535,10.9,10.9,0,0,0-.134,2.139c0,.253,0,.506,0,.757a.776.776,0,0,0,.2.563.641.641,0,0,0,.463.192h.01a.687.687,0,0,0,.66-.745c.007-.329.006-.658,0-.988,0-.247,0-.494,0-.741a3.218,3.218,0,0,1,3.369-3.357c.861-.005,1.723,0,2.584,0l1.457.006.922,0c.93,0,1.863-.009,2.8.011a3.106,3.106,0,0,1,3.049,2.753,13.16,13.16,0,0,1,.059,1.57c0,.2,0,.4,0,.6.006.333.1.892.663.9a.636.636,0,0,0,.441-.164,1,1,0,0,0,.236-.716q0-.8,0-1.594A4.564,4.564,0,0,0,5214.081,1493.19Z",
    fill: "#6291f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M5210.185,1490.638h.016a4.568,4.568,0,0,0,.006-9.136h-.01a4.581,4.581,0,0,0-4.551,4.544,4.564,4.564,0,0,0,4.539,4.592Zm-2.258-6.839a3.207,3.207,0,0,1,2.278-.935h.016a3.207,3.207,0,0,1,3.2,3.24,3.232,3.232,0,0,1-3.213,3.193h-.01a3.22,3.22,0,0,1-2.27-5.5Z",
    fill: "#6291f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M5235.711,1499.073a2.11,2.11,0,0,0-.509-.052q-2.108,0-4.217,0h-5.124q-.935,0-1.869,0a.89.89,0,0,0-.671.238.648.648,0,0,0-.149.512c.045.528.538.607.828.608q5.673,0,11.349,0a1.339,1.339,0,0,0,.365-.051.646.646,0,0,0,.464-.631A.635.635,0,0,0,5235.711,1499.073Z",
    fill: "#6291f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M5235.538,1483.468c-.112-.009-.226-.009-.339-.007h-10.008c-.472,0-.946-.005-1.421.014a.608.608,0,0,0-.6.625.658.658,0,0,0,.6.693,2.575,2.575,0,0,0,.306.008h.114l10.611,0c.253,0,.507.006.76-.012a.662.662,0,0,0-.019-1.322Z",
    fill: "#6291f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M5235.524,1491.243a2.487,2.487,0,0,0-.273,0h-10.959l-.149,0a3.015,3.015,0,0,0-.4.013.648.648,0,0,0-.57.677.629.629,0,0,0,.6.64c.113.011.225.01.339.011h10.379c.349,0,.7.005,1.043-.011a.653.653,0,0,0,.645-.641A.682.682,0,0,0,5235.524,1491.243Z",
    fill: "#6291f4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAge);
export default __webpack_public_path__ + "static/media/age.263d0c736998789886eee6a44edba0ec.svg";
export { ForwardRef as ReactComponent };